// src/components/ChoicePage/ChoicePage.js

import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './ChoicePage.css';
import { themeContext } from 'contexts/theme_context/ThemeContext';

const ChoicePage = () => {
  const navigate = useNavigate();
  const { webtheme } = useContext(themeContext);

  const logoSrc = webtheme === 'light' ? '/Wordmark/Shift Wordmark Black.svg' : '/Wordmark/Shift Wordmark White.svg';

  return (
    <div className={`choice-container ${webtheme}-main-bg`}>
      <div className="choice-card">
        <div className="header">
          <img src={logoSrc} alt="Shift EV" className="logo" />
        </div>
        <h2 className={`${webtheme}-text`}>Welcome! Please choose an option:</h2>
        <div className="buttons-container">
          <button className="btn btn-main" onClick={() => navigate('/customer-portal/operating-analysis')}>
            Customer Portal
          </button>
          <button className="btn btn-secondary-action" onClick={() => navigate('/shiftlens')}>
            ShiftLens (Deprecated)
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChoicePage;
